import { TimeUtil } from "../../../../../util/TimeUtil";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notebookService } from "../../../../../App";
import { storeNote } from "../../../../../slice/noteSlice";
import { CommonUtil } from "../../../../../util/CommonUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createLogger } from "../../../../../utils/logger";
import './NoteCardFloating.css'

const logger = createLogger('NoteCardFloating');

const NoteCardFloating = ({note}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch()


  const onClickItem = async (selectedNote) => {
    logger.debug(`Note clicked: ${selectedNote.id} with notebook: ${selectedNote.note_book_id}`);
    const result = await notebookService.readNoteById(selectedNote.id);
    dispatch(storeNote(result));
    navigate(`/notebook/${selectedNote.note_book_id}`);
  }

  return (
    <>
      <div 
        className="note-card-floating"
        onClick={()=>{onClickItem(note)}}
      >
        <div className="note-card-floating__top">
          <div className="note-card-floating__icon-badge">
            <FontAwesomeIcon icon="book" />
          </div>
          <div className="note-card-floating__meta">
            <div className="note-card-floating__notebook">
              {note.notebook}
            </div>
            <div className="note-card-floating__date">
              {TimeUtil.formatDateWithFormat(note.created,'MMM DD, yyyy')}
            </div>
          </div>
        </div>

        <div className="note-card-floating__title">
          {note.name}
        </div>

        <div className="note-card-floating__preview">
          {CommonUtil.convertHtmlToPlainTextRegex(note.preview)}
        </div>
      </div>
    </>
  );
};

export default NoteCardFloating;
